import { techDocs } from "../technical-docs";

export default techDocs('performance_standards', 'Norma de Desempenho', 'documentos-tecnicos-norma-desempenho')